import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.rolle-benutzer-total';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungRolleBenutzerTotalEffects {

    RolleBenutzerTotal$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_ROLLE_BENUTZER_TOTAL),
        mergeMap((x: ac.GetRolleBenutzerTotalAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getRolleBenutzerTotal().pipe(
                map((result: any) => {
                    return new ac.GetRolleBenutzerTotalErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetRolleBenutzerTotalFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.RollenQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.RollenQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.RollenQueryService);
        }
        return this.service;
    }
}
